import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import GenericFirstHeaderColumn from './GenericFirstHeaderColumn';
import GenericColumnHeader from './GenericColumnHeader';
import GenericDHTCellContent from './GenericDHTCellContent';

const GenericDHTableView = props => {
  const handleScrollBarWidth = () => {
    /* istanbul ignore next */
    $.fn.hasHScrollBar = () => {
      return $('#main-content-grid').get(0)
        ? Math.round($('#main-content-grid').get(0).scrollWidth) >
            Math.round($('#main-content-grid').width())
        : null;
    };
    /* istanbul ignore next */
    $.fn.getScrollWidth = () => {
      const $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body');
      const widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth();
      $outer.remove();
      return 100 - widthWithScroll;
    };
    /* istanbul ignore next */
    const isHScrollBar = $('#main-content-grid').hasHScrollBar();
    /* istanbul ignore next */
    $.fn.hasVScrollBar = () => {
      if (!isHScrollBar) {
        return $('#main-content-grid').get(0)
          ? Math.round($('#main-content-grid').get(0).scrollHeight) >
              Math.round($('#main-content-grid').height())
          : null;
      }
      const scrollWidth = $().getScrollWidth();
      return $('#main-content-grid').get(0)
        ? $('#main-content-grid').get(0).scrollHeight + scrollWidth >
            $('#main-content-grid').height()
        : null;
    };
    /* istanbul ignore next */
    const hasScrollBar = $('#main-content-grid').hasVScrollBar();
    /* istanbul ignore next */
    if (hasScrollBar) {
      const scrollWidth = $().getScrollWidth();
      if ($('.empty-table-header-col').length === 0) {
        if (props.showMainHeader) {
          $('.c-table--header .c-table--row').append(
            `<span class="empty-table-header-col" style="min-width:${scrollWidth}px;width:${scrollWidth}px">
             <div class="head"></div>
             <div class="cell"></div>
             </span>`
          );
        } else {
          $('.c-table--header .c-table--row').append(`<span class="empty-table-header-col"
           style="min-width:${scrollWidth}px;width:${scrollWidth}px">
          <div class="head"></div>
          </span>`);
        }
      }
    } else if ($('.empty-table-header-col').length !== 0) {
      $('.empty-table-header-col').remove();
    }
  };

  // useEffect(() => {
  //   console.log('empty array');
  //   window.addEventListener('resize', handleScrollBarWidth);
  //   // return a function for canceling subscriptions
  //   return () => {
  //     window.removeEventListener('resize', handleScrollBarWidth);
  //   };
  // }, []);
      
 // DidMount Alternative
  useEffect(() => {
    window.addEventListener('resize', handleScrollBarWidth);
    setTimeout(() => {
      handleScrollBarWidth();
    }, 1000);
    return () => {
      window.removeEventListener('resize', handleScrollBarWidth);
    };
  });

  const handleContentScroll = e => {
    const headerMenu = document.getElementById('sub-header-column');
    const leftSideMenu = document.getElementById('left-menu-column');
    if (leftSideMenu) leftSideMenu.scrollTop = e.target.scrollTop;
    if (headerMenu) headerMenu.scrollLeft = e.target.scrollLeft;
  };

  const {
    tableData,
    mainHeaderCol,
    columnHeaders,
    firstHeaderCol,
    firstHeaderColData,
    isCorrTable,
    isClusterSegTable,
    showMainHeader,
    sortOrder,
    sortKey,
    sortColumnIndex,
  } = props;
  /* istanbul ignore next */
  if ($('.empty-table-gen-last-row').length !== 0) {
    $('.empty-table-gen-last-row').remove();
  }
  /* istanbul ignore next */
  if ($('.empty-table-header-col').length > 0) {
    $('.empty-table-header-col').remove();
  }

  return (
    <div data-test="genericDHTableComponent">
      <div className="row expanded main-table">
        <GenericFirstHeaderColumn
          firstHeaderCol={firstHeaderCol}
          showMainHeader={showMainHeader}
        />
        <div
          id="sub-header-column"
          className="column right-column-width gen-right-column-width c-table-container"
        >
          <div className="c-table">
            <div className="c-table--header">
              <div className="c-table--row">
                {mainHeaderCol.map((item, index) => (
                  <GenericColumnHeader
                    key={uuid()}
                    columnHeaders={columnHeaders[index]}
                    mainHeader={item}
                    columnIndex={index}
                    showMainHeader={showMainHeader}
                    onSort={props.onSort}
                    sortOrder={sortOrder}
                    sortKey={sortKey}
                    sortColumnIndex={sortColumnIndex}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row expanded main-content-grid gen-grid-view">
        <div
          className="column left-column-width main-content-grid-left"
          id="left-menu-column"
        >
          {firstHeaderColData.map(row => (
            <div key={uuid()} className="c-table--row row-header-fixed">
              <div className="left-header-content">
                <button
                  type="button"
                  title={row}
                  className='gen-cell-value-next-rows'
                  data-class="obs-l"
                >
                  {row}
                </button>
              </div>
            </div>
          ))}
        </div>
        <div
          id="main-content-grid"
          className="column right-column-width gen-right-column-width main-content-grid-right"
          onScroll={e => handleContentScroll(e)}
        >
          {tableData.map((row, index) => (
            <GenericDHTCellContent
              key={uuid()}
              rowData={row}
              index={index}
              isCorrTable={isCorrTable}
              isClusterSegTable={isClusterSegTable}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

GenericDHTableView.propTypes = {
  tableData: PropTypes.instanceOf(Array),
  mainHeaderCol: PropTypes.instanceOf(Array),
  columnHeaders: PropTypes.instanceOf(Array),
  firstHeaderCol: PropTypes.instanceOf(Array),
  firstHeaderColData: PropTypes.instanceOf(Array),
  isCorrTable: PropTypes.bool,
  isClusterSegTable: PropTypes.bool,
  showMainHeader: PropTypes.bool,
  sortColumnIndex: PropTypes.number,
  sortOrder: PropTypes.string,
  sortKey: PropTypes.string,
  onSort: PropTypes.func,
};

export default GenericDHTableView;
